export default "__VITE_ASSET__9ekE0h9r__"